module.exports = __webpack_public_path__ + "img/gingerman.5ea34704.svg";